<template>
    <div class="financialCenterWrap">
        <div class="container">
            <!-- 合并开票，财务核销切换 -->
            <div class="orderListWrapTab">
                <span v-for='(item, index) in switchTab'
                      :key="index"
                      class="operationChange"
                      :class="{active: index == ind}"
                      @click="switchTabChange(String(index))">
                    <el-tooltip
                            content="新提交开票可以直接合并开票"
                            placement="top"
                            effect="light"
                            :disabled="index !== 1">
                        <el-badge :value="index === 0 ? '新' : '旧' "
                                  :type="index === 0 ? 'danger' : 'info'"
                                  :hidden="index >= 2">
                            {{ item }}
                        </el-badge>
                    </el-tooltip>

                </span>
            </div>

            <!-- 提交开票 -->
            <div v-if="ind === '0'"
                 class="feeOrder">
                <!-- 费用订单 -->
                <div class="orderBillListWrap">
                    <SJMLoading v-if="awaitInvoiceLoading"></SJMLoading>

                    <!-- 合并开票 列表 -->
                    <template>
                        <div style="display: flex; justify-content: space-between;">
                            <div style="width: 70%;">
                                <div class="feeOrderList" style="padding-left: 0;">
                                    <div class="searchWrap" style="margin-left: 24px;">
                                        <span class="text">{{$t('message.pickupDate')}}</span>
                                        <el-date-picker v-model.trim="pickupDateStart"
                                                        type="date"
                                                        class="conditionInput"
                                                        :editable="false"
                                                        value-format="yyyy-MM-dd"
                                                        :placeholder="$t('message.selectDate')">
                                        </el-date-picker>
                                        <span class="text">{{$t('message.dateTo')}}</span>
                                        <el-date-picker v-model.trim="pickupDateEnd"
                                                        value-format="yyyy-MM-dd"
                                                        type="date"
                                                        class="conditionInput"
                                                        :editable="false"
                                                        :placeholder="$t('message.selectDate')">
                                        </el-date-picker>
                                        <el-button class="opeartingBtn"
                                                   type="primary"
                                                   @click="search">
                                            {{$t('message.confirm')}}
                                        </el-button>
                                    </div>
                                </div>
                                <el-table
                                        ref="multipleTable"
                                        key="1"
                                        :data="submitInvoiceList"
                                        tooltip-effect="light"
                                        style="width: 100%;"
                                        :header-cell-style="tableHeaderColor"
                                        max-height="360"
                                        class="table"
                                        @selection-change="submitInvoiceSelectionChange">
                                    <el-table-column
                                            type="selection"
                                            width="55">
                                    </el-table-column>
                                    <el-table-column
                                            prop="drCode"
                                            width="110px"
                                            :label="$t('message.waybillNumber')"
                                            show-overflow-tooltip>
                                    </el-table-column>
                                    <el-table-column
                                            prop="houseBlCode"
                                            :label="$t('message.minorBillCode')"
                                            show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <span>{{scope.row.houseBlCode ? scope.row.houseBlCode : '--'}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            :label="$t('message.pickupDate')"
                                            show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <span>{{scope.row.orderDate ? $moment(Number(scope.row.orderDate)).format('YYYY-MM-DD') : '--'}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            :label="$t('message.amount')"
                                            show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <span>{{$currencyAbbr($getCookie('currency')).split(' ')[0]}}{{scope.row.amount}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            label="月结/付买"
                                            width="80"
                                            show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.isMonthly === '1' ? '月结' : '付买'  }}</span>
                                        </template>
                                    </el-table-column>

                                </el-table>
                            </div>
                            <div style="width: 28%;">
                                <div class="feeOrderList" style="padding-left: 0;">
                                    <p class="title" style="font-size: 16px;">开票中</p>

                                </div>
                                <el-table
                                        ref="multipleTable"
                                        key="11"
                                        :data="processingList"
                                        tooltip-effect="light"
                                        :header-cell-style="tableHeaderColor"
                                        max-height="360"
                                        class="table"
                                        @selection-change="submitInvoiceSelectionChange">
                                    <el-table-column
                                            prop="drCode"
                                            :label="$t('message.waybillNumber')"
                                            width="120px"
                                            show-overflow-tooltip>
                                    </el-table-column>
                                    <el-table-column
                                            prop="houseBlCode"
                                            :label="$t('message.minorBillCode')"
                                            width="70px"
                                            show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <span>{{scope.row.houseBlCode ? scope.row.houseBlCode : '--'}}</span>
                                        </template>
                                    </el-table-column>

                                </el-table>
                            </div>
                        </div>

                        <div class="consolidatedBilling" style="flex-direction: column;">
                            <div class="consolidatedBillingLeft" style="position: relative;">
                                <span class="tit">{{$t('message.Itotalamount')}}:</span>
                                <span class="number">{{submitInvoiceAllCost}}</span>
                            </div>
                            <div>
                                <!-- 开票类型选择 -->
                                <div class="invoiceTypeBox">
                                    <div class="invoiceTypeChoose">
                                        <el-checkbox true-label="2"
                                                     :value="alwaysSelect"
                                                     false-label="-1"
                                                     @change="alwaysSelect=true">{{$t('message.iTelegraphicTicket')}}</el-checkbox>
                                        <el-tooltip placement="top"
                                                    effect="light"
                                                    content="请去结算页开增专">
                                            <el-checkbox true-label="3"
                                                         false-label="-1"
                                                         :disabled="true">{{$t('message.ispecialTicket')}}</el-checkbox>
                                        </el-tooltip>

                                    </div>
                                    <!-- 电子发票提醒 -->
                                    <ul class="electronInvoiceTips">
                                        <li>{{$t('message.aboutElectronicInvoiceTit')}}</li>
                                        <li>{{$t('message.aboutElectronicInvoice1')}}</li>
                                        <li>{{$t('message.aboutElectronicInvoice2')}}</li>
                                        <li>{{$t('message.aboutElectronicInvoice3')}}</li>
                                    </ul>
                                </div>
                                <!-- 填写开票信息 -->
                                <div class="invoiceInfoBox">
                                    <el-collapse-transition>
                                        <div>
                                            <div class="billingStatus">
                                                <p>{{$t('message.billingStatus')}}</p>
                                                <el-checkbox v-model="invoiceMerge"
                                                             class="choice"
                                                             style="color: #409eff;">合并开票（开在一张发票）</el-checkbox>
                                            </div>
                                            <div class="firstRow">
                                                <div>
                                                    <span class="invoiceInfoTitle">{{ $t('message.invoiceName') }}</span>
                                                    <el-select v-model="invoiceSelectIndex"
                                                               class="invoiceInfoInput"
                                                               clearable
                                                               @change="invoiceChoose">
                                                        <el-option v-for="(item,index) in invoiceInfoList"
                                                                   :key="index"
                                                                   :label="item.title"
                                                                   :value="index">
                                                        </el-option>
                                                    </el-select>
                                                </div>
                                                <div>
                                                    <span class="invoiceInfoTitle">{{$t('message.financialMailbox')}}</span>
                                                    <el-input v-model.trim="invoiceInfoData.financialMailbox"
                                                              class="invoiceInfoInput"
                                                              :placeholder="$t('message.pleaseEnterEmail')"></el-input>
                                                    <span class="mailTip">{{ $t('message.emailCanModified') }}</span>
                                                </div>
                                            </div>
                                            <div class="invoiceInfoDetail">
                                                <div v-for="(item,key,index) in invoiceInfoData"
                                                     :key="index"
                                                     class="infoItem">
                                                    <template v-if=" index < 5">
                                                        <span class="infoItemText">
                                                            <span v-if="index < 5" class="redIcon">*</span>
                                                            {{invoiceInfoDataText[key]}}：
                                                        </span>
                                                        <el-input v-model="invoiceInfoData[key]" class="infoItemInput"></el-input>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </el-collapse-transition>
                                    <div class="opeartingBtnBox">
                                        <el-button type="primary"
                                                   class="opeartingBtn"
                                                   @click="postImportBatchApplyInvoiceData">
                                            {{$t('message.submitBilling')}}
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <el-dialog
                                :visible.sync="submitInvoiceDialogVisible"
                                :before-close="submitInvoiceHandleClose"
                                top="30%"
                                width="30%">
                            <div class="postSuccessDialog">
                                <i class="iconfont icon-duihao1"></i>
                                <span class="title">批量提交开票成功</span>
                            </div>
                        </el-dialog>
                    </template>
                </div>
                <!-- 开票账单 -->
                <div class="billing" style="height: 905px;">
                    <div class="billingTop">
                        <p class="title">{{$t('message.IInvoicing')}}</p>
                        <div class="billTitle">
                            <span class="invoiceTitle">{{$t('message.invoiceName')}}：</span>
                            <span>
                                <el-tooltip placement="top">
                                    <div slot="content">{{invoiceInfoData.title}}</div>
                                    <div>
                                        <span class="company">{{invoiceInfoData.title}}</span>
                                    </div>
                                </el-tooltip>
                            </span>
                        </div>
                        <div  class="billTitle">
                            <span>发票数：</span>
                            <span style="margin-right: 5px;">{{ submitInvoiceCount }}</span>张
                        </div>
                        <p class="amountMoney">
                            <span class="amount">所选金额：</span>
                            <span class="money">{{$currencyAbbr($getCookie('currency')).split(' ')[0]}} {{submitInvoiceSelectionCost}}</span>
                        </p>
                    </div>
                    <div class="selectAll" style="height: 680px;">
                        <div v-for="(item,index) in submitInvoiceSelection"
                             :key="index"
                             class="select">
                            <div class="aLine">
                                <span class="name">{{$t('message.waybillNumber')}}</span>
                                <span class="value">{{item.drCode}}</span>
                            </div>
                            <div class="aLine">
                                <span class="name">{{$t('message.minorBillCode')}}</span>
                                <span class="value">{{item.houseBlCode ? item.houseBlCode : '--'}}</span>
                            </div>
                            <div class="aLine">
                                <span class="name">{{$t('message.pickupDate')}}</span>
                                <span class="value">{{item.orderDate ? $moment(Number(item.orderDate)).format('YYYY-MM-DD') : '--'}}</span>
                            </div>
                            <div class="aLine">
                                <span class="name">{{$t('message.amount')}}</span>
                                <span class="value">{{item.amount}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 合并开票列表 -->
            <div v-if="ind === '1'"
                 class="feeOrder">
                <!-- 费用订单 -->
                <div class="orderBillListWrap">
                    <SJMLoading v-if="orderStatusNodeloading"></SJMLoading>
                    <div class="feeOrderList">
                        <!--<p class="title">已确认费用订单</p>-->
                        <div class="searchWrap">
                            <span class="text">开航日期</span>
                            <el-date-picker v-model.trim="arrivalDateStart"
                                            type="date"
                                            class="conditionInput"
                                            :editable="false"
                                            value-format="yyyy-MM-dd"
                                            :placeholder="$t('message.selectDate')">
                            </el-date-picker>
                            <span class="text">至</span>
                            <el-date-picker v-model.trim="arrivalDateEnd"
                                            value-format="yyyy-MM-dd"
                                            type="date"
                                            class="conditionInput"
                                            :editable="false"
                                            :placeholder="$t('message.selectDate')">
                            </el-date-picker>
                            <span class="text">开票抬头</span>
                            <el-input v-model.trim="invoiceTitle" class="invoiceTitle1Input"></el-input>
                            <el-button class="opeartingBtn"
                                       type="primary"
                                       @click="search">
                                确定
                            </el-button>
                        </div>
                    </div>
                    <!-- 合并开票 列表 -->
                    <template>
                        <el-table
                                ref="multipleTable"
                                key="2"
                                :data="invoiceMergeList"
                                tooltip-effect="light"
                                style="width: 100%;"
                                :header-cell-style="tableHeaderColor"
                                max-height="560"
                                class="table"
                                @selection-change="handleSelectionChange">
                            <el-table-column
                                    type="selection"
                                    width="45">
                            </el-table-column>
                            <el-table-column
                                    class="invoiceTitleAll"
                                    prop="invoiceTitle"
                                    sortable
                                    label="开票抬头"
                                    width="140"
                                    show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    prop="drCode"
                                    label="主题单号"
                                    width="130"
                                    show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    label="开航日期"
                                    width="130"
                                    show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <span>{{scope.row.orderDate ? $moment(Number(scope.row.orderDate)).format('YYYY-MM-DD') : '--'}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="线路"
                                    width="125"
                                    show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <span>{{scope.row.startPort}}->{{scope.row.endPort}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="金额"
                                    width="110"
                                    show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <span>¥{{scope.row.amount}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="consolidatedBilling">
                            <div class="consolidatedBillingLeft">
                                <span class="tit">合计金额:</span>
                                <span class="number">{{allNumber}}</span>
                            </div>
                            <el-button type="primary" 
                                       class="consolidatedBillingRight"
                                       :disabled="disabledPostInvoice"
                                       @click="postInvoiceMergeData">
                                提交合并开票
                            </el-button>
                        </div>
                        <el-dialog
                                :visible.sync="dialogVisible"
                                :before-close="handleClose"
                                top="30%"
                                width="30%">
                            <div class="postSuccessDialog">
                                <i class="iconfont icon-duihao1"></i>
                                <span class="title">提交合并开票成功</span>
                            </div>
                        </el-dialog>
                    </template>
                </div>
                <!-- 开票账单 -->
                <div class="billing">
                    <div class="billingTop">
                        <p class="title">开票账单</p>
                        <p class="billTitle">
                            <span class="invoiceTitle">开票抬头：</span>
                            <span v-for="(item,index) in multipleSelection" 
                                  :key="index">
                                <el-tooltip placement="top">
                                    <div slot="content">{{item.invoiceTitle}}</div>
                                    <div>
                                        <span v-if="index === 0"
                                              class="company">{{item.invoiceTitle}}</span>
                                    </div>
                                </el-tooltip>
                            </span>
                        </p>
                        <p class="amountMoney">
                            <span class="amount">总金额：</span>
                            <span class="money">¥ {{allCost}}</span>
                        </p>
                    </div>
                    <div class="selectAll">
                        <div v-for="(item,index) in multipleSelection" 
                             :key="index"
                             class="select">
                            <div class="aLine">
                                <span class="name">主题单号</span>
                                <span class="value">{{item.drCode}}</span>
                            </div>
                            <div class="aLine">
                                <span class="name">开航日期</span>
                                <span class="value">{{item.orderDate ? $moment(Number(item.orderDate)).format('YYYY-MM-DD') : '--'}}</span>
                            </div>
                            <div class="aLine">
                                <span class="name">线路</span>
                                <span class="value">{{item.startPort}}->{{item.endPort}}</span>
                            </div>
                            <div class="aLine">
                                <span class="name">金额</span>
                                <span class="value">{{item.amount}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 财务核销列表 -->
            <div v-if="ind === '2'"
                 class="unwrittenBillsWrap">
                <div class="upperPart">
                    <!-- 未审核账单列表 -->
                    <div class="unwrittenBills">
                        <div class="unwrittenBillTop">
                            <SJMLoading v-if="unwrittenloading"></SJMLoading>
                            <p class="titleLfet">未核销账单</p>
                            <router-link target="_blank" to='/personalCenter/operationCenter/cargoQuery/exportBusiness/writeOffHistory'>
                                <p class="titleRight">查看核销记录</p>
                            </router-link>
                        </div>
                        <div class="searchWrap">
                            <span class="text">开航日期</span>
                            <el-date-picker v-model="dateStart"
                                            type="date"
                                            class="conditionInput"
                                            :editable="false"
                                            value-format="yyyy-MM-dd"
                                            :placeholder="$t('message.selectDate')">
                            </el-date-picker>
                            <span class="text">{{$t('message.dateTo')}}</span>
                            <el-date-picker v-model="dateEnd"
                                            value-format="yyyy-MM-dd"
                                            type="date"
                                            class="conditionInput"
                                            :editable="false"
                                            :placeholder="$t('message.selectDate')">
                            </el-date-picker>
                            <el-button class="opeartingBtn"
                                       type="primary"
                                       @click="search">
                                确定
                            </el-button>
                        </div>
                        <template>
                            <el-table
                                    ref="multipleTable"
                                    key="3"
                                    :data="unwrittenBillList"
                                    tooltip-effect="light"
                                    class="elTable"
                                    style="width: 100%;"
                                    :header-cell-style="tableHeaderColor"
                                    max-height="300"
                                    @selection-change="pickSelectionChange">
                                <el-table-column
                                        type="selection"
                                        width="45">
                                </el-table-column>
                                <el-table-column
                                        label="发票号"
                                        width="100"
                                        show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <a v-if="scope.row.electronicInvoiceDown !== ''"
                                           target="_blank"
                                           :href="scope.row.electronicInvoiceDown"
                                           :class="{active: scope.row.electronicInvoiceDown !== ''}"
                                           :title="scope.row.invoiceNo">
                                            {{scope.row.invoiceNo}}
                                        </a>
                                        <span v-else
                                              style="font-size: 14px;">{{scope.row.invoiceNo}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="运单号"
                                        width="130">
                                    <template slot-scope="scope">
                                        <el-tooltip placement="top-start">
                                            <div slot="content">
                                                <div v-for="(item, index) in scope.row.orderInfoList" :key="index">{{item.drCode}}</div>
                                            </div>
                                            <div v-for="(item, index) in scope.row.orderInfoList" 
                                                 :key="index"
                                                 class="ellipsisText">
                                                <span v-if="scope.row.orderInfoList.length > 1">{{item.drCode}}...</span>
                                                <span v-else>{{item.drCode}}</span>
                                            </div>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="开航日期"
                                        width="100">
                                    <template slot-scope="scope">
                                        <el-tooltip placement="top-start">
                                            <div slot="content">
                                                <div v-for="(item, index) in scope.row.orderInfoList" :key="index">{{item.orderDate ? $moment(Number(item.orderDate)).format('YYYY-MM-DD') : '--'}}</div>
                                            </div>
                                            <div v-for="(item, index) in scope.row.orderInfoList" 
                                                 :key="index"
                                                 class="ellipsisText">
                                                <span v-if="scope.row.orderInfoList.length > 1">{{item.orderDate ? $moment(Number(item.orderDate)).format('YYYY-MM-DD') : '--'}}...</span>
                                                <span>{{item.orderDate ? $moment(Number(item.orderDate)).format('YYYY-MM-DD') : '--'}}</span>
                                            </div>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="金额"
                                        width="80">
                                    <template slot-scope="scope">
                                        <span>¥{{scope.row.amount}}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="consolidatedBilling">
                                <div class="consolidatedBillingLeft">
                                    <span class="tit">合计金额:</span>
                                    <span class="number">¥{{pickAllCost}}</span>
                                </div>
                                <el-button v-if="pickSelection.length === 0"
                                           type="primary"
                                           class="consolidatedBillingRight"
                                           disabled>
                                    确认核销
                                </el-button>
                                <el-button v-else-if="Number(pickAllCost) > Number(remainingAmountAllCost)"
                                           type="primary"
                                           class="consolidatedBillingRight"
                                           disabled>
                                    银行打款记录不能小于未核销账单
                                </el-button>
                                <el-button v-else
                                           type="primary"
                                           class="consolidatedBillingRight"
                                           @click="postBillWriteOffData">
                                    确认核销
                                </el-button>
                            </div>
                            <el-dialog
                                    :visible.sync="bullWriteloading"
                                    :before-close="postbull"
                                    top="30%"
                                    width="30%">
                                <div class="postSuccessDialog">
                                    <i class="iconfont icon-duihao1"></i>
                                    <span class="title">核销成功</span>
                                </div>
                            </el-dialog>
                        </template>
                    </div>
                    <!-- 银行打款记录列表 -->
                    <div class="paymentRecord">
                        <div class="unwrittenBillTop">
                            <SJMLoading v-if="paymentloading"></SJMLoading>
                            <p class="titleLfet">银行打款记录</p>
                            <router-link target="_blank" to="/personalCenter/operationCenter/cargoQuery/exportBusiness/paymentRecord">
                                <p class="titleRight">查看历史打款记录</p>
                            </router-link>
                        </div>
                        <template>
                            <el-table
                                    ref="multipleTable"
                                    key="4"
                                    :data="bankPaymentRecordList"
                                    tooltip-effect="light"
                                    style="width: 100%;"
                                    :header-cell-style="tableHeaderColor"
                                    max-height="300">
                                <el-table-column
                                        label="银行"
                                        width="100">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.bankName}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="打款时间"
                                        width="130">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.paymentTime ? $moment(Number(scope.row.paymentTime)).format('YYYY-MM-DD') : '--'}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="打款金额"
                                        width="120">
                                    <template slot-scope="scope">
                                        <span>¥{{scope.row.paymentAmount}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="剩余金额"
                                        width="100">
                                    <template slot-scope="scope">
                                        <span>¥{{scope.row.remainingAmount}}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="consolidatedBilling">
                                <div class="consolidatedBillingLeft">
                                    <span class="tit">剩余总金额:</span>
                                    <span class="number">¥{{remainingAmountAllCost}}</span>
                                </div>
                                <router-link target="_blank" to='/personalCenter/operationCenter/cargoQuery/exportBusiness/paymentDistribution'>
                                    <el-button class="distribution" type="primary">打款分配</el-button>
                                </router-link>
                            </div>
                        </template>
                    </div>
                </div>
                <!-- 选中未核销账单列表 -->
                <SJMLoading v-if="paymentloading"></SJMLoading>
                <div class="lowerPart">
                    <template>
                        <div class="lowerPartList">
                            <el-table
                                    ref="multipleTable"
                                    key="5"
                                    :data="pickSelection"
                                    :span-method="objectSpanMethod"
                                    tooltip-effect="light"
                                    style="width: 100%; border: 1px solid #f4f4f4;"
                                    class="selectList"
                                    :header-cell-style="tableHeaderColor"
                                    max-height="365">
                                <el-table-column
                                        label="运单号"
                                        width="230">
                                    <template slot-scope="scope">
                                        <div v-for="(item, index) in scope.row.orderInfoList" 
                                             :key="index"
                                             class="tabTop">
                                            <span>{{item.drCode ? item.drCode : '--'}}</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="开航日期"
                                        width="230">
                                    <template slot-scope="scope">
                                        <div v-for="(item, index) in scope.row.orderInfoList" 
                                             :key="index"
                                             class="tabTop">
                                            <span>{{item.orderDate ? $moment(Number(item.orderDate)).format('YYYY-MM-DD') : '--'}}</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="最晚付款日期"
                                        width="230">
                                    <template slot-scope="scope">
                                        <div v-for="(item, index) in scope.row.orderInfoList" 
                                             :key="index"
                                             class="tabTop">
                                            <span>{{item.payLastTime ? $moment(Number(item.payLastTime)).format('YYYY-MM-DD') : '--'}}</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="金额"
                                        width="170">
                                    <template slot-scope="scope">
                                        <div v-for="(item, index) in scope.row.orderInfoList" 
                                             :key="index"
                                             class="tabTop">
                                            <span>¥{{item.amount}}</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="发票号"
                                        width="148"
                                        class="tabTop">
                                    <template slot-scope="scope">
                                        <div>{{scope.row.invoiceNo ? scope.row.invoiceNo : '--'}}</div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FinanceManagementMain',// 出口财务中心
        data() {
            return {
                // 列表第一行颜色
                tableHeaderColor ({rowIndex}) {
                    if (rowIndex === 0) {
                        return 'background-color: #F3F3F3;';
                    }
                },
                ind: '0',// 切换合并开票，财务核销
                type: '1',// 进出口 0-出口、1-进口

                orderStatusNodeloading: true,// 订单状态节点loading
                unwrittenloading: true,// 未核销账单loading
                paymentloading: true,// 银行打款记录loading

                // 搜索条件
                arrivalDateStart: '',// 到港日期始
                arrivalDateEnd: '',// 到港日期止
                currentDate: '',// 当天时间戳
                invoiceTitle: '',

                dateStart: '',// 未核销账单搜索日期
                dateEnd: '',// 未核销账单搜索日期


                // 勾选数据
                // 合并开票选中的数据
                multipleSelection: [],
                // 未核销账单选中的数据
                pickSelection: [],

                // 数据列表
                // 合并开票列表（以申请开票ID为单位）
                invoiceMergeList: [],
                // 未核销账单（以开票号为单位、有开票号且未核销数据）
                unwrittenBillList: [],
                // 银行打款记录（有剩余金额）
                bankPaymentRecordList: [],

                
                dialogVisible: false,// 合并开票弹框
                bullWriteloading: false,// 确认核销弹框
                betweenMonth: '',

                awaitInvoiceLoading: true,// 提交开票loading
                pickupDateStart: '',// 提货日期开始
                pickupDateEnd: '',// 提货日期结束
                submitInvoiceList: [], // 提交开票列表
                submitInvoiceSelection: [],// 提交开票选中的数据
                submitInvoiceDialogVisible: false,// 提交开票弹框

                emailReg: this.$store.state.Regular.email,// 邮箱正则
                titlevalue: [], // 开票抬头集合
                invoiceMerge: false, // 合并开票
                invoiceSelectIndex: '',// 选择的开票抬头index
                invoiceInfoList: [],// 历史开票抬头信息
                invoiceInfoDataText: {
                    title: this.$t('message.invoiceName'),// 开票抬头
                    taxId: this.$t('message.taxpayerIdNumber'),// 纳税人识别号
                    bankName: this.$t('message.openBank'),// 开户银行
                    bankAccount: this.$t('message.bankAccount'),// 银行账号
                    increaseTicketAddressPhone: this.$t('message.increaseTicketAddress'),// 增票地址电话
                    expressContactInfo: this.$t('message.shippingContactInformation'),// 寄票联系信息
                    expressPhone: this.$t('message.shippingCall'),// 寄票电话
                    expressContact: this.$t('message.shippingContact'),// 寄票联系人
                },
                invoiceInfoData: {
                    title: '',// 开票抬头
                    taxId: '',// 纳税人识别号
                    bankName: '',// 开户银行
                    bankAccount: '',// 银行账号
                    increaseTicketAddressPhone: '',// 增票地址电话
                    expressContactInfo: '',// 寄票联系信息
                    expressPhone: '',// 寄票电话
                    expressContact: '',// 寄票联系人
                    isRecent: '',// 是否最近使用 0-N、1-Y
                    financialMailbox: '',// 财务邮箱（选付买时显示）
                },
                alwaysSelect: true,
                processingList: []
            };
        },
        computed: {
            switchTab() {
                return [
                    '提交开票' + '(' + this.submitInvoiceList.length + ')',
                    this.$t('message.mergeInvoice') + '(' + this.invoiceMergeList.length + ')',
                    this.$t('message.a2ddlda') + '(' + this.unwrittenBillList.length + ')'
                ];
            },
            // 提交开票总金额
            submitInvoiceAllCost() {
                return this.$realCost(this.submitInvoiceList.map(i => i.amount));
            },
            submitInvoiceSelectionCost() {
                return this.$realCost(this.submitInvoiceSelection.map(i => i.choosen ? i.amount : 0));
            },
            submitInvoiceCount() {
                if (this.invoiceMerge && this.submitInvoiceSelection.length > 0) {
                    return 1;
                } else {
                    return this.submitInvoiceSelection.length;
                }
            },
            // 合并开票总金额
            allCost() {
                return this.$realCost(this.multipleSelection.map(i => i.choosen ? i.amount : 0));
            },
            // 合计总金额
            allNumber() {
                return this.$realCost(this.invoiceMergeList.map(i => i.amount));
            },
            // 未核销账单总金额
            pickAllCost() {
                return this.$realCost(this.pickSelection.map(i => i.pickChoosen ? i.amount : 0));
            },
            // 银行打款记录剩余总金额
            remainingAmountAllCost() {
                return this.$realCost(this.bankPaymentRecordList.map(i => i.remainingAmount ? i.remainingAmount : 0)); 
            },
            // 提交合并开票 禁用
            disabledPostInvoice() {
                // 合并 50w or 单票 80w
                return (this.multipleSelection.length === 1 ? Number(this.allCost) > 800000 : Number(this.allCost) > 500000)
                    || this.multipleSelection.length === 0;
            },
            // 确认核销 禁用
            noWriteOff() {
                return this.pickSelection.length === 0;
            },
        },
        created() {
            this.getImportAwaitApplyInvoiceData();
            // 加载进口合并开票数据
            this.getInvoiceMergeListData();
            this.getUnwrittenBillListData();
            this.getBankPaymentRecordListData();

            if (this.$route.query.orderBillListType === 0) {
                this.ind = '0';
            }
            if (this.$route.query.orderBillListType === 1) {
                this.ind = '2';
            }
        },
        methods: {
            // 合并开票关闭跳转财务核销页面
            handleClose() {
                this.ind = '2';
                this.dialogVisible = false;
                this.getInvoiceMergeListData();
                this.getUnwrittenBillListData();
            },
            // 核销成功关闭弹框
            postbull() {
                this.getUnwrittenBillListData();
                this.getBankPaymentRecordListData();
                this.bullWriteloading = false;
            },
            // 表格合并
            objectSpanMethod(rowIndex, columnIndex) {
                if (columnIndex === 0) {
                    if (rowIndex % 2 === 0) {
                        return {
                            rowspan: 1,
                            colspan: 1
                        };
                    }
                }
            },
            
            // 搜索条件初始化
            conditionInit() {
                // 到港日期初始化
                this.arrivalDateStart = this.$moment(this.currentDate).subtract(6, 'months').format('YYYY-MM-DD');
                // 到港日期止
                this.arrivalDateEnd = '';
            },

            // 合并开票选中的数据
            handleSelectionChange(val) {
                this.multipleSelection = val;
                this.multipleSelection.map(i => {
                    i.choosen = true;
                });

                // 合并 50w or 单票 80w
                if (this.allCost > 500000 && this.multipleSelection.length > 1) {
                    this.$Message({
                        msg: '已超限额，合并开票最大不超过50万！'
                    });
                }
                if (this.allCost > 800000 && this.multipleSelection.length === 1) {
                    this.$Message({
                        msg: '已超限额，合并开票单票最大不超过80万！'
                    });
                }

                this.multipleSelection.forEach(i => {
                    if (i.invoiceTitle !== this.multipleSelection[0].invoiceTitle) {
                        this.$refs.multipleTable.toggleRowSelection(i);
                        this.$Message({
                            msg: '请选择一样的开票抬头！'
                        });
                    }
                });
            },

            // 未核销账单选中的数据
            pickSelectionChange(val) {
                this.pickSelection = val;
                this.pickSelection.map(i => {
                    i.pickChoosen = true;
                });
            },
            // 合并开票，财务核销切换
            switchTabChange(index) {
                this.ind = index;
                this.search();
            },
            search() {
                // 提交开票列表
                if (this.ind === '0') {
                    this.getImportAwaitApplyInvoiceData();
                }
                // 合并开票列表
                else if (this.ind === '1') {
                    this.getInvoiceMergeListData();
                }
                // 财务核销
                else if (this.ind === '2') {
                    this.getUnwrittenBillListData();
                    this.getBankPaymentRecordListData();
                }
            },
            // 获取 进口合并开票数据 
            getInvoiceMergeListData() {
                this.$ajax({
                    url: '/personalCenterHandler/financeCenter/FinanceManagementHandler.ashx',
                    data: {
                        act: 'getInvoiceMergeListData',// 获取待合并开票列表数据
                        type: this.type,// 进出口 0-出口、1-进口
                        dateStart: this.arrivalDateStart,// 出口开航日期、进口提货日期始（可能传空字符串）
                        dateEnd: this.arrivalDateEnd,// 出口开航日期、进口提货日期期止（可能传空字符串）
                        invoiceTitle: this.invoiceTitle
                    },
                    beforeSend: () => {
                        this.orderStatusNodeloading = true;
                    },
                    success: (res) => {
                        this.invoiceMergeList = res.success.invoiceMergeList.map(i => {
                            return {
                                ...i,
                                choosen: false,
                            };
                        });
                        this.multipleSelection = [];

                        this.orderStatusNodeloading = false;

                    },
                    complete: () => {
                    }
                });
            },

            // 获取 提交合并开票
            postInvoiceMergeData() {
                this.$ajax({
                    url: '/personalCenterHandler/financeCenter/FinanceManagementHandler.ashx',
                    data: {
                        act: 'postInvoiceMergeData',// 提交开票合并数据
                        accountIdList: JSON.stringify(this.multipleSelection.map(i => i.accountId)),// 申请开票ID列表
                        type: '0',
                    },
                    beforeSend: () => {
                        this.orderStatusNodeloading = true;
                    },
                    success: (res) => { 
                        this.betweenMonth = res.success.betweenMonth;   
                        
                        this.orderStatusNodeloading = false;
                        if (this.betweenMonth === '0') {
                            this.$ajax({
                                url: '/personalCenterHandler/financeCenter/FinanceManagementHandler.ashx',
                                data: {
                                    act: 'postInvoiceMergeData',// 提交开票合并数据
                                    accountIdList: JSON.stringify(this.multipleSelection.map(i => i.accountId)),// 申请开票ID列表
                                    type: '1',
                                },
                                beforeSend: () => {
                                    this.orderStatusNodeloading = true;
                                },
                                success: () => {
                                    this.dialogVisible = true;     
                                },
                                complete: () => {
                                    this.orderStatusNodeloading = false;
                                }
                            });    
                        } else {
                            this.orderStatusNodeloading = false;
                            this.$alert('合并开票订单中存在跨月订单，请核实是否和贵司财务付款制度相符，如无异议可继续提交','提示',{
                                callback: (action) => {
                                    if (action === 'confirm') {
                                        this.$ajax({
                                            url: '/personalCenterHandler/financeCenter/FinanceManagementHandler.ashx',
                                            data: {
                                                act: 'postInvoiceMergeData',// 提交开票合并数据
                                                accountIdList: JSON.stringify(this.multipleSelection.map(i => i.accountId)),// 申请开票ID列表
                                                type: '1',
                                            },
                                            beforeSend: () => {
                                                this.orderStatusNodeloading = true;
                                            },
                                            success: () => {
                                                this.dialogVisible = true;     
                                            },
                                            complete: () => {
                                                this.orderStatusNodeloading = false;
                                            }
                                        }); 
                                    }
                                    
                                }
                            });                         
                        }
                    },
                    error: () => {
                        this.orderStatusNodeloading = false;
                    },
                    errCallback: () => {
                        this.orderStatusNodeloading = false;
                    },               
                    complete: () => {
                        
                    }
                });
            },

            // 获取 获取未核销列表数据
            getUnwrittenBillListData() {
                this.$ajax({
                    url: '/personalCenterHandler/financeCenter/FinanceManagementHandler.ashx',
                    data: {
                        act: 'getUnwrittenBillListData',// 获取未核销列表数据
                        type: this.type,// 进出口 0-出口、1-进口
                        dateStart: this.dateStart,// 出口开航日期、进口提货日期始（可能传空字符串）
                        dateEnd: this.dateEnd,// 出口开航日期、进口提货日期期止（可能传空字符串）
                    },
                    beforeSend: () => {
                        this.unwrittenloading = true;
                    },
                    success: (res) => {
                        this.unwrittenBillList = res.success.unwrittenBillList.map(i => {
                            return {
                                ...i,
                                pickChoosen: false,
                            };
                        });
                        this.unwrittenloading = false;
                    },
                });
            },
            
            // 获取 确认核销
            postBillWriteOffData() {
                this.$ajax({
                    url: '/personalCenterHandler/financeCenter/FinanceManagementHandler.ashx',
                    data: {
                        act: 'postBillWriteOffData',// 提交开票合并数据
                        checkCodeList: JSON.stringify(this.pickSelection.map(i => i.checkCode)),// 开票号列表
                    },
                    beforeSend: () => {
                        this.unwrittenloading = true;
                    },
                    success: () => {
                        this.bullWriteloading = true;
                        this.unwrittenloading = false;
                    },
                });
            },

            // 获取 获取银行打款记录数据
            getBankPaymentRecordListData() {
                this.$ajax({
                    url: '/personalCenterHandler/financeCenter/FinanceManagementHandler.ashx',
                    data: {
                        act: 'getBankPaymentRecordListData',// 获取未核销列表数据
                    },
                    beforeSend: () => {
                        this.paymentloading = true;
                    },
                    success: (res) => {
                        this.bankPaymentRecordList = res.success.bankPaymentRecordList;
                        this.paymentloading = false;
                    },
                    complete: () => {
                    }
                });
            },

            // 获取进口待申请开票的数据
            getImportAwaitApplyInvoiceData() {
                this.$ajax({
                    url: '/personalCenterHandler/financeCenter/FinanceManagementHandler.ashx',
                    data: {
                        act: 'getImportAwaitApplyInvoiceData',// 获取待合并开票列表数据
                        dateStart: this.pickupDateStart,// 出口开航日期、进口提货日期始（可能传空字符串）
                        dateEnd: this.pickupDateEnd,// 出口开航日期、进口提货日期期止（可能传空字符串）
                    },
                    beforeSend: () => {
                        this.awaitInvoiceLoading = true;
                        this.submitInvoiceSelection = [];
                        this.drawinvoice();
                    },
                    success: (res) => {
                        this.submitInvoiceList = res.success.awaitApplyList.map(i => {
                            return {
                                ...i,
                                choosen: false,
                            };
                        });
                        this.processingList = res.success.processingList;
                        this.awaitInvoiceLoading = false;

                    },
                    complete: () => {
                        this.awaitInvoiceLoading = false;
                    }
                });
            },

            // 提交进口批量申请开票的数据
            postImportBatchApplyInvoiceData() {
                let orderBillCodeList = this.submitInvoiceSelection.map(i => i.orderBillCode);


                // 验证
                let messageText = '';
                if (orderBillCodeList.length === 0) {
                    messageText = '请先选择订单';
                }
                else if (this.invoiceInfoData.financialMailbox === '') {
                    messageText = this.$t('message.pleaseEnterFinancialEmail');
                } else if (!this.emailReg.test(this.invoiceInfoData.financialMailbox)) {
                    messageText = this.$t('message.financialEmailEnterErr');
                } else if (this.invoiceInfoData.title === '') {
                    messageText = this.$t('message.b5sdbr');
                } else if (this.invoiceInfoData.taxId === '') {
                    messageText = this.$t('message.b4wdqd');
                } else if (this.invoiceInfoData.bankName === '') {
                    messageText = this.$t('message.b2wddf');
                } else if (this.invoiceInfoData.bankAccount === '') {
                    messageText = this.$t('message.b1dskd');
                } else if (this.invoiceInfoData.increaseTicketAddressPhone === '') {
                    messageText = this.$t('message.a2ddld');
                }

                if (messageText) {
                    this.$Message({
                        msg: messageText
                    });
                    return;
                }
                
                // 税号必须18位
                if (this.invoiceType !== '0' && this.invoiceInfoData.taxId.length !== 18) {
                    this.$Alert({
                        msg: '纳税人识别号必须为18位'
                    });
                    return;
                }

                let multMonth = this.submitInvoiceSelection.filter(v => Number(v.amount) > 0).map(v => v.orderDate ? this.$moment(Number(v.orderDate)).format('YYYY-MM') : '--');
                multMonth = this.$distinct(multMonth);

                if (this.invoiceMerge && multMonth.length > 1) {
                    this.$alert('合并开票订单中存在跨月订单，请核实是否和贵司财务付款制度相符，如无异议可继续提交','提示',{
                        callback: (action) => {
                            if (action === 'confirm') {
                                this.$ajax({
                                    url: '/personalCenterHandler/financeCenter/FinanceManagementHandler.ashx',
                                    data: {
                                        act: 'postImportBatchApplyInvoiceData',// 提交进口批量申请开票的数据
                                        orderBillCodeList: JSON.stringify(orderBillCodeList),// 托单号
                                        invoiceType: '2',// 开票类型 0-DEBIT NOTE、2-增值税普通发票（电票）、3-增值税专用发票（纸票）
                                        financialMailbox: this.invoiceInfoData.financialMailbox,// 财务邮箱
                                        invoiceMerge: this.invoiceMerge === true ? '1' : '0',// 合并开票 1-合并开票、0-单独开票（同一托书多次提交开票，需保持一致）
                                        // 开票信息 若不开票 发送空对象
                                        invoiceInfo: JSON.stringify(this.invoiceType === '0' ? {} : this.invoiceInfoData),
                                    },
                                    beforeSend: () => {
                                        this.awaitInvoiceLoading = true;
                                    },
                                    success: () => {
                                        this.submitInvoiceDialogVisible = true;
                                    },
                                    complete: () => {
                                        this.awaitInvoiceLoading = false;
                                    }
                                });
                            }

                        }
                    });
                }
                else {
                    this.$ajax({
                        url: '/personalCenterHandler/financeCenter/FinanceManagementHandler.ashx',
                        data: {
                            act: 'postImportBatchApplyInvoiceData',// 提交进口批量申请开票的数据
                            orderBillCodeList: JSON.stringify(orderBillCodeList),// 托单号
                            invoiceType: '2',// 开票类型 0-DEBIT NOTE、2-增值税普通发票（电票）、3-增值税专用发票（纸票）
                            financialMailbox: this.invoiceInfoData.financialMailbox,// 财务邮箱
                            invoiceMerge: this.invoiceMerge === true ? '1' : '0',// 合并开票 1-合并开票、0-单独开票（同一托书多次提交开票，需保持一致）
                            // 开票信息 若不开票 发送空对象
                            invoiceInfo: JSON.stringify(this.invoiceType === '0' ? {} : this.invoiceInfoData),
                        },
                        beforeSend: () => {
                            this.awaitInvoiceLoading = true;
                        },
                        success: () => {
                            this.submitInvoiceDialogVisible = true;
                        },
                        complete: () => {
                            this.awaitInvoiceLoading = false;
                        }
                    });
                }


            },

            submitInvoiceHandleClose() {
                this.ind = '0';
                this.submitInvoiceDialogVisible = false;
                this.getImportAwaitApplyInvoiceData();
            },

            submitInvoiceSelectionChange(val) {
                this.submitInvoiceSelection = val;
                this.submitInvoiceSelection.map(i => {
                    i.choosen = true;
                });
            },
            drawinvoice() {
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/unmanned/ImportAssignOrderHandler.ashx',
                    data: {
                        act: 'getImportInvoiceInfoData',// 获取进口开票抬头的数据
                    },
                    beforeSend: () => {

                    },
                    success: (res) => {
                        this.titlevalue = res.success.invoiceInfoList;
                        this.invoiceInfoList = res.success.invoiceInfoList;
                        this.invoiceInfoList.forEach(i => {
                            if (i.isRecent === '1') {
                                this.invoiceSelectIndex = i.title;
                                this.invoiceInfoData.title = i.title;
                                this.invoiceInfoData.taxId = i.taxId;
                                this.invoiceInfoData.expressPhone = i.expressPhone;
                                this.invoiceInfoData.bankAccount = i.bankAccount;
                                this.invoiceInfoData.increaseTicketAddressPhone = i.increaseTicketAddressPhone;
                                this.invoiceInfoData.expressContactInfo = i.expressContactInfo;
                                this.invoiceInfoData.bankName = i.bankName;
                                this.invoiceInfoData.expressContact = i.expressContact;
                                this.invoiceInfoData.financialMailbox = i.financialMailbox;
                            }
                        });


                    },
                    complete: () => {

                    }
                });
            },

            // 切换开票抬头
            invoiceChoose() {
                for (let key in this.invoiceInfoData) {
                    this.invoiceInfoData[key] = this.invoiceInfoList[this.invoiceSelectIndex][key];
                }
            },
            choice() {
                for (let key in this.invoiceInfoData) {
                    this.invoiceInfoData[key] = this.options[this.invoiceSelectIndex][key];
                }
            },
        }
    };
</script>

<style  lang="scss" scoped>
    .financialCenterWrap {
        position: relative;
        width: 1070px;
        padding: 0;
        margin: 0;
        overflow: hidden;
        background-color: #f3f3f4;

        .container {
            width: 1070px;
            min-height: 650px;
            margin: 0 auto;

            .orderListWrapTab {
                display: flex;
                padding: 26px 0 0 32px;
                background-color: #fff;
                border-bottom: 1px solid #eeeeef;

                span {
                    display: inline-block;
                    height: 32px;
                    font-size: 16px;
                    line-height: 22px;
                    color: #aaa;
                    cursor: pointer;
                }

                :nth-child(2),
                :nth-child(3) {
                    margin-left: 100px;
                }

                .active {
                    color: #181818;
                    border-bottom: 2px solid #009fe8;
                }
            }

            .feeOrder {
                display: flex;
                justify-content: space-between;

                .orderBillListWrap {
                    position: relative;
                    width: 710px;
                    background-color: #fff;

                    .feeOrderList {
                        display: flex;
                        justify-content: space-between;
                        width: 650px;
                        height: 70px;
                        padding: 0 30px;

                        .title {
                            font-size: 18px;
                            line-height: 70px;
                        }

                        /* 搜索栏  */
                        .searchWrap {
                            position: relative;
                            display: flex;
                            align-items: center;
                            height: 70px;
                            margin-bottom: 12px;

                            .text {
                                margin-right: 12px;
                                font-size: 16px;
                            }

                            .conditionInput {
                                width: 130px;
                                margin-right: 12px;
                            }

                            .opeartingBtn {
                                margin-right: 15px;

                                &:last-child {
                                    margin: 0;
                                }
                            }

                            .invoiceTitle1Input {
                                width: 100px;
                                margin-right: 5px;

                                /deep/ .el-input__inner {
                                    padding: 0 4px;
                                }
                            }
                        }
                    }

                    // 隐藏table滚动条
                    /deep/ .el-table--scrollable-y ::-webkit-scrollbar {
                        display: none;
                    }

                    .consolidatedBilling {
                        display: flex;
                        justify-content: space-between;
                        padding: 30px;

                        .consolidatedBillingLeft {
                            position: absolute;
                            bottom: 20px;

                            .tit {
                                font-size: 16px;
                            }

                            .number {
                                margin-left: 10px;
                                font-size: 20px;
                                color: #d0021b;
                            }
                        }

                        .invoiceTypeBox {
                            box-sizing: border-box;
                            //width: 1145px;
                            padding-left: 35px;
                            margin-bottom: 15px;
                            box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.15);

                            .invoiceTypeChoose {
                                position: relative;
                                display: flex;
                                padding: 20px 0;

                                /deep/ .el-checkbox {
                                    display: flex;
                                    align-items: center;
                                    margin-right: 80px;
                                    color: #0aa7ee;

                                    .el-checkbox__input.is-checked + .el-checkbox__label {
                                        color: #0aa7ee;
                                    }
                                }
                            }

                            .electronInvoiceTips {
                                padding-bottom: 20px;
                                line-height: 20px;
                                color: #9b9b9b;
                            }
                        }

                        .invoiceInfoBox {
                            .billingStatus {
                                display: flex;
                                margin-bottom: 10px;

                                .choice {
                                    margin-left: 30px;
                                }
                            }

                            .firstRow {
                                display: flex;
                                align-items: center;
                                margin-bottom: 15px;

                                .invoiceInfoTitle {
                                    margin-right: 12px;
                                    font-size: 14px;
                                }

                                .invoiceInfoInput {
                                    width: 186px;
                                    margin-right: 30px;
                                }

                                .mailTip {
                                    font-size: 16px;
                                    color: #aaa;
                                }
                            }

                            .invoiceInfoDetail {
                                display: flex;
                                flex-wrap: wrap;
                                margin-bottom: 20px;
                                overflow: hidden;

                                .infoItem {
                                    display: flex;
                                    align-items: center;
                                    justify-content: flex-end;
                                    margin-right: 10px;

                                    /* width: 285px; */
                                    margin-bottom: 10px;
                                    color: #727171;

                                    .infoItemText {
                                        font-size: 12px;
                                        text-align: right;

                                        .redIcon {
                                            color: #e51a40;
                                        }
                                    }

                                    .infoItemInput {
                                        width: 128px;
                                    }
                                }

                                .eninfoItem {
                                    flex-wrap: wrap;
                                    justify-content: flex-start;
                                    width: 265px;
                                }

                                .enwidth {
                                    width: 295px;
                                }

                                .enwidth1 {
                                    width: 268px;
                                    margin-left: 30px;
                                }
                            }

                            .opeartingBtnBox {
                                display: flex;
                                justify-content: flex-end;

                                .opeartingBtn {
                                    width: 140px;
                                    height: 44px;
                                    font-size: 18px;
                                    border-radius: 8px;
                                }

                                .enopeartionBtn {
                                    width: auto;
                                }
                            }
                        }

                        .consolidatedBillingRight {
                            position: absolute;
                            right: 30px;
                            bottom: 20px;
                            width: 180px;
                            height: 44px;
                            font-size: 18px;
                            border-radius: 8px;
                        }
                    }

                    .postSuccessDialog {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        padding: 40px;

                        .iconfont {
                            margin-bottom: 18px;
                            font-size: 74px;
                            color: #67c23a;
                        }

                        .title {
                            margin-top: 5px;
                            font-size: 22px;
                            font-weight: 500;
                        }
                    }
                }

                .billing {
                    position: relative;
                    box-sizing: border-box;
                    width: 348px;
                    height: 734px;
                    padding: 0 30px;
                    white-space: nowrap;
                    background-color: #fff;

                    .billingTop {
                        padding-left: 8px;
                        margin-top: 25px;

                        .title {
                            align-items: center;
                            margin-top: 25px;
                            font-size: 18px;
                        }

                        .billTitle {
                            display: flex;
                            align-items: center;
                            margin-top: 25px;
                            font-size: 18px;

                            .company {
                                display: inline-block;
                                width: 188px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                        }

                        .amountMoney {
                            margin-top: 25px;

                            .amount {
                                font-size: 18px;
                                font-weight: 500;
                            }

                            .money {
                                margin-left: 20px;
                                font-size: 20px;
                                color: #d0021b;
                            }
                        }
                    }

                    .selectAll {
                        height: 540px;
                        margin-top: 20px;
                        overflow-y: auto;

                        .select {
                            box-sizing: border-box;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            width: 295px;
                            height: 138px;
                            padding: 10px 20px;
                            margin: auto;
                            margin-top: 20px;
                            background-image: url('~@/assets/img/personalCenter/operationCenter/cargoQuery/importBusiness/billingBackground.png');
                            background-repeat: no-repeat;
                            background-position: 0 44px;
                            box-shadow: 0 1px 5px 1px rgba(0, 0, 0, 0.2);

                            .aLine {
                                .name {
                                    display: inline-block;
                                    width: 90px;
                                }
                            }
                        }
                    }

                    .selectAll::-webkit-scrollbar {
                        display: none;
                    }
                }
            }
            // 财务核销
            .unwrittenBillsWrap {
                width: 1070px;
                padding: 0;
                margin: 0;
                overflow: hidden;

                .upperPart {
                    display: flex;
                    justify-content: space-between;

                    // 未审核账单列表
                    .unwrittenBills {
                        position: relative;
                        box-sizing: border-box;
                        width: 530px;
                        height: 487px;
                        padding: 0 30px;
                        background-color: #fff;

                        .unwrittenBillTop {
                            display: flex;
                            justify-content: space-between;
                            margin-top: 20px;

                            .titleLfet {
                                font-size: 18px;
                                font-weight: 500;
                            }

                            .titleRight {
                                width: 100px;
                                height: 24px;
                                line-height: 24px;
                                color: #0aa7ee;
                                text-align: center;
                                cursor: pointer;
                                border: 1px solid #0aa7ee;
                                border-radius: 4px;
                            }
                        }

                        .searchWrap {
                            position: relative;
                            display: flex;
                            align-items: center;
                            height: 70px;
                            margin-bottom: 12px;

                            .text {
                                margin-right: 12px;
                                font-size: 16px;
                            }

                            .conditionInput {
                                width: 130px;
                                margin-right: 12px;
                            }

                            .opeartingBtn {
                                margin-right: 15px;

                                &:last-child {
                                    margin: 0;
                                }
                            }
                        }

                        .elTable {
                            width: 500px;
                            margin: 0 auto;

                            .ellipsisText {
                                width: 100%;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }

                            .active {
                                color: #009fe8;
                            }
                        }

                        // 隐藏table滚动条
                        /deep/ .el-table--scrollable-y ::-webkit-scrollbar {
                            display: none;
                        }

                        .consolidatedBilling {
                            display: flex;
                            justify-content: space-between;
                            padding: 30px;

                            .consolidatedBillingLeft {
                                position: absolute;
                                bottom: 20px;

                                .tit {
                                    font-size: 16px;
                                }

                                .number {
                                    margin-left: 10px;
                                    font-size: 20px;
                                    color: #d0021b;
                                }
                            }

                            .consolidatedBillingRight {
                                position: absolute;
                                right: 30px;
                                bottom: 20px;
                            }
                        }

                        .postSuccessDialog {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            padding: 40px;

                            .iconfont {
                                margin-bottom: 18px;
                                font-size: 74px;
                                color: #67c23a;
                            }

                            .title {
                                margin-top: 5px;
                                font-size: 22px;
                                font-weight: 500;
                            }
                        }
                    }

                    // 银行打款记录列表
                    .paymentRecord {
                        position: relative;
                        box-sizing: border-box;
                        width: 530px;
                        height: 487px;
                        padding: 0 30px;
                        background-color: #fff;

                        .unwrittenBillTop {
                            display: flex;
                            justify-content: space-between;
                            margin-top: 20px;
                            margin-bottom: 82px;

                            .titleLfet {
                                font-size: 18px;
                                font-weight: 500;
                            }

                            .titleRight {
                                width: 128px;
                                height: 24px;
                                line-height: 24px;
                                color: #0aa7ee;
                                text-align: center;
                                cursor: pointer;
                                border: 1px solid #0aa7ee;
                                border-radius: 4px;
                            }
                        }

                        // 隐藏table滚动条
                        /deep/ .el-table--scrollable-y ::-webkit-scrollbar {
                            display: none;
                        }

                        .consolidatedBilling {
                            display: flex;
                            justify-content: space-between;
                            padding: 30px;

                            .consolidatedBillingLeft {
                                position: absolute;
                                bottom: 20px;

                                .tit {
                                    font-size: 16px;
                                }

                                .number {
                                    margin-left: 10px;
                                    font-size: 20px;
                                    color: #d0021b;
                                }
                            }

                            .distribution {
                                position: absolute;
                                right: 30px;
                                bottom: 20px;
                            }
                        }
                    }
                }

                // 选中未核销账单列表
                .lowerPart {
                    width: 100%;
                    height: 366px;
                    margin-top: 15px;
                    background-color: #fff;

                    .lowerPartList {
                        padding: 10px 30px;
                        background-color: #fff;

                        .tabTop {
                            height: 50px;
                            padding-left: 10px !important;
                            line-height: 50px;
                            border-top: 1px solid #f4f4f4;
                        }
                    }
                }

                // 隐藏table滚动条
                /deep/ .el-table--scrollable-y ::-webkit-scrollbar {
                    display: none;
                }
            }
        }
    }
</style>

<style lang="scss">

    .selectList {
        tr td {
            padding: 0 !important;
        }

        .has-gutter tr th {
            padding-left: 10px !important;
        }

        .cell {
            padding: 0 !important;
        }

        .el-table_8_column_40 {
            text-align: center;
            border-left: 1px solid #f4f4f4;
        }

        .el-table_4_column_20 {
            text-align: center;
            border-left: 1px solid #f4f4f4;
        }
    }

</style>